import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import content from '../../translations/content.json';
import { CalendarDays } from 'lucide-react';
import './style.css';

const timeSlots = [
  { id: '1', time: '09:00 - 10:00 AM IST', available: false },
  { id: '2', time: '11:00 - 12:00 PM IST', available: true },
  { id: '3', time: '02:00 - 03:00 PM IST', available: true },
  { id: '4', time: '04:00 - 05:00 PM IST', available: true },
];

const BookDemoPage = () => {
  const { bookDemoPage } = content;
  const [date, setDate] = useState(new Date());
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleDateChange = (newDate) => {
    setDate(newDate);
  };

  const handleSlotSelect = (slot) => {
    if (slot.available) {
      setSelectedSlot(slot.id);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedSlot) {
      alert(bookDemoPage.alerts.selectSlot);
      return;
    }

    const bookingDetails = {
      date: date.toDateString(),
      timeSlot: timeSlots.find(slot => slot.id === selectedSlot).time,
    };

    try {
      const response = await fetch('http://localhost:8000/book-demo', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bookingDetails),
      });

      if (response.ok) {
        setIsSubmitted(true);
      } else {
        alert(bookDemoPage.alerts.bookingFailed);
      }
    } catch (error) {
      console.error('Error booking demo:', error);
      alert('An error occurred. Please try again later.');
    }
  };

  const isSunday = (d) => d.getDay() === 0;

  return (
    <div className="book-demo-page-container">
      <div className="book-demo-header">
        <h1>
          <CalendarDays className="inline-block w-8 h-8 mr-3 -mt-1" />
          {bookDemoPage.header.title}
        </h1>
        <p>{bookDemoPage.header.subtitle}</p>
      </div>
      {isSubmitted ? (
        <div className="confirmation-message">
          <h2>{bookDemoPage.confirmation.title}</h2>
          <p>{bookDemoPage.confirmation.message}</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="booking-content-wrapper">
          <div className="calendar-card">
            <Calendar
              onChange={handleDateChange}
              value={date}
              tileDisabled={({ date }) => isSunday(date)}
            />
          </div>
          <div className="time-slots-card">
            <h2>{bookDemoPage.slots.title}</h2>
            <div className="slots">
              {timeSlots.map((slot) => (
                <button
                  key={slot.id}
                  type="button"
                  className={`slot ${selectedSlot === slot.id ? 'selected' : ''} ${!slot.available ? 'disabled' : ''}`}
                  onClick={() => handleSlotSelect(slot)}
                  disabled={!slot.available}
                >
                  {slot.time}
                </button>
              ))}
            </div>
            <button type="submit" className="btn-submit-demo">{bookDemoPage.slots.submit}</button>
          </div>
        </form>
      )}
    </div>
  );
};

export default BookDemoPage;
